import React from 'react';
import { Check } from 'lucide-react';
import Reveal from '../ui/Reveal';
import RegistrationForm from './RegistrationForm';

interface RegistrationSectionProps {
  fechaLabel: string;
  horaLabel: string;
}

const BENEFITS = [
  'Acceso 100% gratuito',
  'Grupo privado de WhatsApp con recordatorios',
  'El Método WITS explicado paso a paso',
];

const RegistrationSection: React.FC<RegistrationSectionProps> = ({ fechaLabel, horaLabel }) => {
  return (
    <section id="registro" className="relative scroll-mt-36 py-24 md:py-28">
      <div className="mx-auto max-w-7xl px-5">
        <Reveal className="grid overflow-hidden rounded-[28px] border border-white/10 bg-white/5 backdrop-blur-md md:grid-cols-2">
          <div
            className="relative hidden flex-col justify-between overflow-hidden p-8 md:flex md:p-12"
            style={{ background: 'linear-gradient(160deg, rgba(218,35,157,.14), rgba(63,134,255,.14))' }}
          >
            <img
              src="/images/06-masterclass/masterclass-7.jpeg"
              alt="Estudiante en una clase online en vivo"
              loading="lazy"
              className="absolute inset-0 h-full w-full animate-kenburns object-cover opacity-30"
            />
            <div
              className="absolute inset-0"
              style={{ background: 'linear-gradient(160deg, rgba(9,15,48,.72), rgba(7,12,36,.92))' }}
            />
            <div
              className="pointer-events-none absolute -bottom-16 -left-10 h-56 w-56 rounded-full blur-3xl"
              style={{ background: 'radial-gradient(circle, rgba(104,63,250,.5), transparent 65%)' }}
            />
            <div className="relative">
              <img src="/images/01-homepage/logoinfinitywits.svg" alt="Infinity Wits" className="mb-6 h-10 w-auto" />
              <h2 className="font-display text-3xl font-extrabold leading-tight">
                Reserva tu <span className="text-gradient-mc">acceso gratuito</span>
              </h2>
              <p className="mt-3 font-light text-white/70">
                Completa tus datos para reservar tu lugar en la clase online en vivo.
              </p>
            </div>
            <ul className="relative mt-8 space-y-3 text-sm text-white/80">
              {BENEFITS.map((benefit) => (
                <li key={benefit} className="flex items-center gap-2.5">
                  <Check size={16} className="text-mc-fuchsia" />
                  {benefit}
                </li>
              ))}
            </ul>
          </div>

          <div className="p-8 md:p-12">
            <h3 className="mb-2 font-display text-2xl font-bold md:hidden">
              Reserva tu <span className="text-gradient-mc">acceso gratuito</span>
            </h3>
            <RegistrationForm fechaLabel={fechaLabel} horaLabel={horaLabel} />
            <p className="mt-5 text-xs leading-relaxed text-white/55">
              Al completar tu registro recibirás las indicaciones para ingresar al grupo privado de WhatsApp, donde
              compartiremos los recordatorios y la información para participar en la clase.
            </p>
            <p className="mt-2 text-[11px] leading-relaxed text-white/40">
              Tus datos serán utilizados para gestionar tu registro y las comunicaciones relacionadas con la clase,
              conforme a la política de privacidad aplicable.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default RegistrationSection;
